import { useState, useMemo } from "react";
import List from "@/components/List";
import ListRow from "@/components/Row/ListRow/index";
import ContentHeader from "@/components/ContentHeader";
import DateTab from "@/components/DateTab";
import { useChannelLiveScheduleQuery } from "@/hooks";
import NoContentMessage from "@/components/NoContentMessage";
import dayjs from "@/lib/day";
import styles from "@/styles/Channel.module.scss";
import { LIST_PAGE_LIMIT } from "@/lib/constants";

export default function ChannelLiveSchedule({ id }) {
  const [selectedDay, setDay] = useState(dayjs().format("YYYY-MM-DD"));
  const { data, ...result } = useChannelLiveScheduleQuery({
    variables: { id, day: selectedDay, offset: 0, limit: LIST_PAGE_LIMIT },
  });
  const items = data?.channelLiveSchedule;

  const headerText = useMemo(
    () => `${dayjs(selectedDay).format("M/D（dd）")}の番組`,
    [selectedDay]
  );

  return (
    <div className={styles.liveSchedule}>
      <ContentHeader text={headerText} />
      <div>
        <DateTab selectedDay={selectedDay} onClick={setDay} />
      </div>
      <div className={styles.content}>
        <List
          key={`channel-${id}-live-${selectedDay}`}
          {...result}
          itemComponent={ListRow}
          items={items}
          limit={LIST_PAGE_LIMIT}
          noContent={
            <NoContentMessage message="この日のライブはありません。" />
          }
        />
      </div>
    </div>
  );
}
